import React from "react";
import { Box, Typography, Button, Paper, Alert } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

export default function CognitoAiFileUploadFailedPane({
  error,
  onRetry,
  onClose,
}) {
  return (
    <Box sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4, textAlign: "center" }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <ErrorIcon sx={{ fontSize: 80, color: "error.main" }} />
        </Box>

        <Typography variant="h5" gutterBottom>
          Upload Failed
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          There was an error uploading your file.
        </Typography>

        <Alert severity="error" sx={{ mb: 3, textAlign: "left" }}>
          <Typography variant="body2">
            {error || "An unknown error occurred. Please try again."}
          </Typography>
        </Alert>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
          <Button variant="contained" onClick={onRetry}>
            Retry Upload
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
